import * as React from 'react';

import classnames from 'classnames';
import moment from 'moment';
import PropTypes from 'prop-types';

import {TimePicker} from '../date-time-picker/time-picker';
import {Popover} from '../popover/popover';

import styles from './editable-timestamp.module.css';

export class EditableTimestamp extends React.PureComponent {
    static propTypes = {
        formattedValue: PropTypes.string.isRequired,
        value: PropTypes.number.isRequired,
        onTimeChange: PropTypes.func,
    };

    constructor(props) {
        super(props);
        this.state = {
            isOpen: false,
        };
    }

    render() {
        const styleNames = classnames(null, {
            [styles['container-editable'] || '']: this.props.onTimeChange,
            [styles['container-open'] || '']: this.state.isOpen,
        });

        return (
            <div className={styleNames}>
                <div
                    onClick={this.handleOpenPopover}
                    ref={(c) => {
                        this.timestamp = c;
                    }}
                    className={styles.timestamp}
                >
                    {this.props.formattedValue}
                </div>
                {this.state.isOpen ? (
                    <Popover
                        className='ui-popover'
                        location='bottom'
                        onBlur={this.handleClosePopover}
                        anchor={this.timestamp}
                    >
                        <div
                            onClick={(e) => {
                                e.stopPropagation();
                            }}
                        >
                            <TimePicker
                                date={new Date(moment.unix(this.props.value).startOf('minute'))}
                                onSelect={this.handleSelect}
                            />
                        </div>
                    </Popover>
                ) : undefined}
            </div>
        );
    }

    handleOpenPopover = (e) => {
        if (this.props.onTimeChange) {
            e.stopPropagation();
            e.preventDefault();
            this.setState({isOpen: true});
        }
    };

    handleClosePopover = (e) => {
        if (e) {
            e.stopPropagation();
        }
        this.setState({isOpen: false});
    };

    handleSelect = (date) => {
        this.setState({isOpen: false});
        this.props.onTimeChange(date);
    };
}
